// import Repository from './Repository'
const baseDomain = process.env.VUE_APP_API_URL
const baseURL = `${baseDomain}/sale/api/v1`
const resource = '/process'
const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Expose-Headers': '*',
}

export default {
  /**
   * マイソク一覧を取得
   */
  get() {
    return new Promise((resolve, reject) => {
      axios({
        headers: headers,
        withCredentials: true,
        url: `${baseURL}${resource}/generate/maisoku`,
        method: `GET`,
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * マイソク出力用ファイルを取得する
   * @param {Array} ids 物件ID
   * @param {Number} type POP種別
   * @param {Number} f_is_private オリジナルマイソク判定フラグ
   */
  download(ids, type, f_is_private) {
    const params = {
      b_regular_ids: ids,
      type: type,
      f_is_private: f_is_private,
    }
    return new Promise((resolve, reject) => {
      axios({
        headers: headers,
        withCredentials: true,
        url: `${baseURL}${resource}/generate/maisoku`,
        method: 'POST',
        responseType: 'blob', // これがないと文字化けする
        params: params,
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
